import React, { useState } from 'react'
import SuggestLocation, { ILocationSuggestion } from 'transfix-ui/components/SuggestLocation'

export interface ILaneLocationSearchValues {
  city?: string
  stateCode?: string
}

interface ILaneLocationSearch {
  id: string
  hasValue: boolean
  placeholder: string
  className?: string
  dataTest?: string
  onChange: (id: string, location?: ILaneLocationSearchValues) => void
  isLarge?: boolean
  errorMessage?: string
  label?: string
  required?: boolean
}

const LaneLocationSearch = ({
  className = '',
  dataTest,
  errorMessage = '',
  hasValue,
  id,
  isLarge = true,
  label = '',
  onChange,
  placeholder,
  required = false,
}: ILaneLocationSearch) => {
  const [current, setCurrent] = useState<ILocationSuggestion | undefined>(undefined)

  const changeHandler = (value: ILocationSuggestion) => {
    setCurrent(value)
    const { city, state: stateCode } = value
    const locationValues =
      Object.values(value).filter(Boolean).length > 1 ? { city, stateCode } : undefined
    onChange(id, locationValues)
  }

  return (
    <div className={className}>
      <SuggestLocation
        onChange={changeHandler}
        value={hasValue ? current : undefined}
        placeholder={placeholder}
        dataTest={dataTest}
        resultTypes={['City']}
        id={id}
        large={isLarge}
        errorMessage={errorMessage}
        label={label}
        required={required}
      />
    </div>
  )
}

export default LaneLocationSearch
